import { render, staticRenderFns } from "./ModalPreviewImg.vue?vue&type=template&id=1e273663&scoped=true"
import script from "./ModalPreviewImg.vue?vue&type=script&lang=js"
export * from "./ModalPreviewImg.vue?vue&type=script&lang=js"
import style0 from "./ModalPreviewImg.vue?vue&type=style&index=0&id=1e273663&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e273663",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e273663')) {
      api.createRecord('1e273663', component.options)
    } else {
      api.reload('1e273663', component.options)
    }
    module.hot.accept("./ModalPreviewImg.vue?vue&type=template&id=1e273663&scoped=true", function () {
      api.rerender('1e273663', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewImg.vue"
export default component.exports